"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by Anushavan.Hovsepyan on 11/23/2016.
 */
var core_1 = require("@angular/core");
var sis_select_item_directive_1 = require("../shared/sis-select-item.directive");
/**
 * @deprecated use {@link SelectItemDirective} instead.
 * MenuItemDirective for initializing menu item.
 * Gets as input:
 *      data - The array of objects, which contains options data.
 *      value - The option value.
 *      name - The option name.
 *      group - The group of item.
 *      isEnabled - If item is enabled.
 *      valueField - The value field name.
 *      nameField - The name field name.
 *      groupField - The criteria name of grouping.
 *      isEnabledField - The enabled field name.
 * The valueField, the nameField, the groupField and the isEnabledField can be used only with data.
 */
var MenuItemDirective = /** @class */ (function (_super) {
    __extends(MenuItemDirective, _super);
    function MenuItemDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MenuItemDirective_1 = MenuItemDirective;
    MenuItemDirective = MenuItemDirective_1 = __decorate([
        core_1.Directive({
            selector: "sis-menu-item, sis-menu-items",
            providers: [{ provide: sis_select_item_directive_1.SelectItemDirective, useExisting: core_1.forwardRef(function () { return MenuItemDirective_1; }) }],
        })
    ], MenuItemDirective);
    return MenuItemDirective;
    var MenuItemDirective_1;
}(sis_select_item_directive_1.SelectItemDirective));
exports.MenuItemDirective = MenuItemDirective;
//# sourceMappingURL=sis-menu-item.directive.js.map